export default () => '/';
